export type VoiceCapturePhase = "idle" | "permission" | "recording" | "transcribing";

let activeVoiceCaptureOwner: symbol | null = null;

export const acquireVoiceCaptureLease = (owner: symbol): boolean => {
  if (activeVoiceCaptureOwner !== null) {
    return activeVoiceCaptureOwner === owner;
  }
  activeVoiceCaptureOwner = owner;
  return true;
};

export const ownsVoiceCaptureLease = (owner: symbol): boolean => activeVoiceCaptureOwner === owner;

export const releaseVoiceCaptureLease = (owner: symbol): void => {
  if (activeVoiceCaptureOwner === owner) {
    activeVoiceCaptureOwner = null;
  }
};

export const shouldIgnoreVoiceCaptureRequest = (args: {
  requestId: number;
  activeRequestId: number;
  currentPhase: VoiceCapturePhase;
  owner: symbol;
}): boolean => args.requestId !== args.activeRequestId || args.currentPhase !== "permission" || !ownsVoiceCaptureLease(args.owner);

export const pickVoiceRecordingMimeType = (): string | null => {
  if (typeof MediaRecorder === "undefined") {
    return null;
  }
  const candidates = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4", "audio/aac"];
  return candidates.find(candidate => MediaRecorder.isTypeSupported(candidate)) ?? null;
};

export const isBrowserVoiceRecordingSupported = (): boolean =>
  typeof window !== "undefined" &&
  typeof navigator !== "undefined" &&
  Boolean(navigator.mediaDevices?.getUserMedia) &&
  typeof MediaRecorder !== "undefined" &&
  pickVoiceRecordingMimeType() !== null;

export const appendVoiceTranscript = (draft: string, transcript: string): string => {
  const cleanTranscript = transcript.trim();
  if (!cleanTranscript) {
    return draft;
  }
  if (!draft) {
    return cleanTranscript;
  }
  return `${draft}${/\s$/.test(draft) ? "" : " "}${cleanTranscript}`;
};
